/* eslint-disable react/prop-types */
import { func, string } from 'prop-types'
import React from 'react'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import iconAdicionar from '../../assets/imagens/icon-add.svg'
import styled from 'styled-components'

const Botao = styled.button`
  background-color: ${StyleGuide.cores.cinza100};
  background-image: ${`linear-gradient(90deg, #c0c0c094, #c0c0c094 75%, transparent 75%, transparent 100%, transparent 100%), linear-gradient(90deg, #c0c0c094, #c0c0c094 75%, transparent 75%, transparent 100%, transparent 100%), linear-gradient(-180deg, #c0c0c094, #c0c0c094 75%, transparent 75%, transparent 100%, transparent 100%), linear-gradient(-180deg, #c0c0c094, #c0c0c094 75%, transparent 75%, transparent 100%, transparent 100%)`};
  background-position: left top, left bottom, left top, right top;
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: 15px 2px, 15px 2px, 2px 15px, 2px 15px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  ${( { margin } ) => margin && `margin: ${margin};`}
  outline: none;
  width: 100%;
  ${( { type } ) => type === 'cartao' && `height: 177px;`}
  ${( { type } ) => ( type === 'cartao' ? `padding: 0` : 'padding: 52px;' )}

  @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
    padding: 35px 68px;
    ${( { marginMobile } ) => marginMobile && `margin: ${marginMobile};`}
  }
`

const Icon = styled.span`
  background-image: url( ${iconAdicionar} );
  background-size: cover;
  display: block;
  height: 68px;
  margin: 0 auto 20px;
  width: 68px;

  @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
    height: 50px;
    width: 50px;
  }
`

const Titulo = styled.h2`
  ${StyleGuide.tipografia.textoDefault};
  color: ${StyleGuide.cores.cinza300};
  margin: 0;
`

const CardAdicionar = ( { margin, marginMobile, onClick, titulo, type, ...props } ) => {
  return (
    <Botao
      margin={ margin }
      marginMobile={ marginMobile }
      onClick={ onClick }
      type={ type }
      { ...props }
    >
      <Icon />
      <Titulo>{titulo}</Titulo>
    </Botao>
  )
}

CardAdicionar.propTypes = {
  'margin': string,
  'marginMobile': string,
  'onClick': func,
  'titulo': string
}

CardAdicionar.defaultProps = {
  'margin': '',
  'marginMobile': '',
  'onClick': () => {},
  'titulo': ''
}

export default CardAdicionar
